import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { patchRequest, postRequest } from 'apis/ApiInstence';

const SUBJECTS = ['Residential', 'Commercial', 'Industrial', 'Townships', 'Farmhouses', 'Other'];

const initialFormState = {
  name: '',
  mobile: '',
  email: '',
  alternate_email: '',
  location: '',
  subject: '',
  is_active: true,
};

const toFormUrlEncoded = (payload) => {
  const encoded = new URLSearchParams();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    encoded.append(key, String(value));
  });
  return encoded;
};

const AddExpertCalling = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const expertToEdit = location.state?.expertToEdit;

  useEffect(() => {
    if (!expertToEdit) return;
    setFormData({
      name: expertToEdit.name || '',
      mobile: expertToEdit.mobile || '',
      email: expertToEdit.email || '',
      alternate_email: expertToEdit.alternate_email || '',
      location: expertToEdit.location || '',
      subject: expertToEdit.subject || '',
      is_active: expertToEdit.is_active !== undefined ? Boolean(expertToEdit.is_active) : true,
    });
  }, [expertToEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.name.trim(),
      mobile: formData.mobile.trim(),
      email: formData.email.trim(),
      location: formData.location.trim() || undefined,
      alternate_email: formData.alternate_email.trim() || null,
      subject: formData.subject,
      is_active: Boolean(formData.is_active),
    };

    if (!payload.name || !payload.mobile || !payload.email) {
      toast.error('Name, mobile and email are required');
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      const encodedPayload = toFormUrlEncoded(payload);
      const headers = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };
      const request = expertToEdit?.id
        ? patchRequest(`expertCalling/${expertToEdit.id}`, encodedPayload, headers)
        : postRequest('expertCalling', encodedPayload, headers);

      const response = await request;

      if (response?.data?.success) {
        toast.success(
          response.data.message || (expertToEdit?.id ? 'Expert updated successfully' : 'Expert created successfully')
        );
        setFormData(initialFormState);
        navigate('/expertcalling');
      } else {
        toast.error(response?.data?.message || 'Failed to save expert calling. Please try again.');
      }
    } catch (error) {
      toast.error(error?.message || 'Failed to save expert calling. Please try again.');
      console.error('There was a problem saving expert calling:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">{expertToEdit?.id ? 'Update Expert Call' : 'Add A Expert Call'}</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="customer_data">
          <div className="col-sm-6 mt-2">
            <label htmlFor="expert_name">Name *</label>
            <input
              type="text"
              id="expert_name"
              placeholder="Enter Expert Name"
              name="name"
              value={formData.name}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="expert_mobile">Mobile *</label>
            <input
              type="text"
              id="expert_mobile"
              name="mobile"
              placeholder="Enter Mobile Number"
              value={formData.mobile}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="expert_email">Email *</label>
            <input
              type="email"
              id="expert_email"
              name="email"
              placeholder="Enter Email"
              value={formData.email}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="expert_alt_email">Alternate Email</label>
            <input
              type="email"
              id="expert_alt_email"
              name="alternate_email"
              placeholder="Enter Alternate Email (optional)"
              value={formData.alternate_email}
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="expert_location">Location</label>
            <input
              type="text"
              id="expert_location"
              name="location"
              placeholder="Enter Location"
              value={formData.location}
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="expert_subject">Subject</label>
            <select
              id="expert_subject"
              name="subject"
              value={formData.subject}
              className="form-control"
              onChange={handleChange}
            >
              <option value="">Select Subject</option>
              {SUBJECTS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div className="col-sm-6 mt-4">
            <div className="form-check">
              <input
                type="checkbox"
                id="expert_is_active"
                name="is_active"
                className="form-check-input"
                checked={Boolean(formData.is_active)}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="expert_is_active">
                Active
              </label>
            </div>
          </div>
        </div>
        <div className="mt-4 text-right mx-4">
          <button className="btn addbtn" disabled={submitting}>
            {submitting ? 'Saving...' : expertToEdit?.id ? 'Update Expert Calling' : 'Add Expert Calling'}
          </button>
        </div>
      </form>
    </div >
  );
};

export default AddExpertCalling;
